import { ThemeColors, IpsaGreyPurple } from './HighchartsStyleHelper'

const GlobalHighchartOptions = {
    global: {
        useUTC: false,
    },
    credits: {
        enabled: false,
    },
    lang: {
        decimalPoint: '.',
        thousandsSep: ',',
    },
    loading: {
        style: { backgroundColor: '#0f0835', opacity: '1' },
    },
    chart: {
        //By default (when null) the height is calculated from the offset height of the containing element, or 400 pixels if the containing element's height is 0.
        // height: (9 / 24) * 100 + '%',
        // height: '56%',
    },

    plotOptions: {
        column: {
            dataLabels: {
                enabled: false,
                align: 'center',
                // Need to do formatting per graph. Not a public all graphs type thing
                // format: '${y:,.2f}',
                style: {
                    fontSize: '18px',
                },
            },
            grouping: false,
            maxPointWidth: '250',
        },
    },
    tooltip: {
        // Need to do formatting per graph. Not a public all graphs type thing

        // headerFormat: '<span>{series.name}</span><br/>',
        // pointFormat: '<b>Value ${point.y:,.2f}</b>',
        style: {
            fontSize: '18px',
        },
    },
    legend: {
        itemStyle: {
            fontSize: '14px',
            fontWeight: 100,
        },
    },
    xAxis: {
        labels: {
            style: {
                color: 'white',
                cursor: 'default',
                fontSize: '16px',
                fontWeight: 600,
            },
        },
    },
    title: {
        style: {
            fontSize: '30px',
        },
    },
    yAxis: {
        labels: {
            // Need to do formatting per graph. Not a public all graphs type thing
            // format: '${value:,.0f}',
            style: {
                fontSize: '18px',
            },
        },
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 247, // equivalent to the sidebar breakpoint of 1280px on the screen
                },
                // Make the labels less space demanding on mobile
                chartOptions: {
                    title: {
                        style: {
                            fontSize: '18px',
                        },
                    },
                },
            },
        ],
    },
}

const GlobalHighchartsStyleOptions = {
    colors: ThemeColors,
    chart: {
        backgroundColor: 'transparent',
        style: { fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif' },
        plotBorderColor: '#FFF',
    },
    title: {
        style: {
            color: '#FFF',
            fontWeight: 700,
            lineHeight: 1.1,
            marginBottom: '0.67em',
            fontSize: '26px',
        },
    },
    subtitle: { style: { color: '#FFF' } },
    xAxis: {
        allowDecimals: false,
        gridLineColor: '#FFF',
        labels: { style: { color: '#FFF' } },
        lineColor: '#FFF',
        minorGridLineColor: IpsaGreyPurple,
        tickColor: '#FFF',
        title: { style: { color: '#A0A0A3' } },
    },
    yAxis: {
        allowDecimals: false,
        gridLineColor: '#707073',
        labels: { style: { color: '#FFF' } },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: { style: { color: '#A0A0A3' } },
    },
    tooltip: { backgroundColor: 'rgba(17, 17, 17, 0.60)', style: { color: '#F0F0F0' } },
    plotOptions: {
        series: {
            dataLabels: {
                color: '#d3d3d3',
                style: {
                    textOutline: '0px',
                    fontWeight: 'bold',
                    fontSize: '24px',
                },
            },
            marker: { lineColor: '#333' },
        },
        boxplot: { fillColor: '#505053' },
        candlestick: { lineColor: 'white' },
        errorbar: { color: 'white' },
    },
    legend: {
        itemStyle: { color: '#FFF' },
        itemHoverStyle: { color: IpsaGreyPurple },
        itemHiddenStyle: { color: '#333333' },
    },
    // credits: { style: { color: '#666' } },
    labels: { style: { color: '#707073' } },
    drilldown: {
        activeAxisLabelStyle: { color: '#F0F0F3' },
        activeDataLabelStyle: { color: '#F0F0F3', textDecoration: 'none' },
        drillUpButton: {
            position: {
                x: 0,
                y: -20,
            },
        },
    },
    navigation: { buttonOptions: { symbolStroke: '#DDDDDD', theme: { fill: '#505053' } } },
    rangeSelector: {
        buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: { color: '#CCC' },
            states: {
                hover: { fill: '#707073', stroke: '#000000', style: { color: 'white' } },
                select: { fill: '#000003', stroke: '#000000', style: { color: 'white' } },
            },
        },
        inputBoxBorderColor: '#505053',
        inputStyle: { backgroundColor: '#333', color: 'silver' },
        labelStyle: { color: 'silver' },
    },
    navigator: {
        handles: { backgroundColor: '#666', borderColor: '#AAA' },
        outlineColor: '#CCC',
        maskFill: 'rgba(255,255,255,0.1)',
        series: { color: '#7798BF', lineColor: '#A6C7ED' },
        xAxis: { gridLineColor: '#505053' },
    },
    scrollbar: {
        barBackgroundColor: '#808083',
        barBorderColor: '#808083',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: '#606063',
        buttonBorderColor: '#606063',
        rifleColor: '#FFF',
        trackBackgroundColor: '#404043',
        trackBorderColor: '#404043',
    },
    legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
    background2: '#505053',
    dataLabelsColor: '#B0B0B3',
    textColor: '#C0C0C0',
    contrastTextColor: '#F0F0F3',
    maskColor: 'rgba(255,255,255,0.3)',
}

export { GlobalHighchartOptions, GlobalHighchartsStyleOptions }
